import { Box, Skeleton, VStack } from "@chakra-ui/react";

export default function SkeletonCard() {
  return (
    <Box p={4} borderRadius="lg" borderWidth="1px" height="100%">
      <VStack align="stretch" gap={4}>
        <Skeleton height="20px" width="40%" />
        <Skeleton height="100px" />
        <Skeleton height="20px" width="60%" />
      </VStack>
    </Box>
  );
} 